import { createSelector } from 'reselect';
const selectRateConversation = (state) => state.rateConversation;
export const selectRate = createSelector([selectRateConversation], (rateConversation) => rateConversation.rate);
export const selectRateHover = createSelector([selectRateConversation], (rateConversation) => rateConversation.rateHover);
export const selectIsRateConversationOpen = createSelector([selectRateConversation], (rateConversation) => rateConversation.isOpen);
